import {
  UiButtonAlignType,
  UiButtonExpandType,
  UiButtonRoundType,
  UiButtonSizeType,
  UiButtonVariantType,
} from './types';

export const uiButtonClassNames = {
  get root(): string {
    return 'ui-button-base';
  },

  size(size: UiButtonSizeType): string {
    return `${this.root}--size-${size}`;
  },

  variant(variant: UiButtonVariantType): string {
    return `${this.root}--variant-${variant}`;
  },

  round(round: UiButtonRoundType): string {
    return `${this.root}--round-${round}`;
  },

  expand(expand: UiButtonExpandType): string {
    return `${this.root}--expand-${expand}`;
  },

  align(align: UiButtonAlignType): string {
    return `${this.root}--align-${align}`;
  },

  get active(): string {
    return `${this.root}--active`;
  },

  get iconOnly(): string {
    return `${this.root}--icon-only`;
  },

  get spinner(): string {
    return `${this.root}-spinner`;
  },

  get icon(): string {
    return `${this.root}__icon`;
  },
};
